import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'

import { onError } from 'apollo-link-error'
import history from './history'

const link = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    history.push('/login')
  }
});

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`,
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = sessionStorage.getItem('user_jwt');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
})

const client = new ApolloClient({
  link: link.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache()
})

export default client


// WEBPACK FOOTER //
// ./src/configureApolloClient.js